const FORBIDDEN_URLS = {
  CHECKOUT: {
    FROM: ['/liste', '/ayagina-gelsin'],
    TO: '/ayagina-gelsin?m_redir=0',
  },
};

const BRAND_PAGE_WEBTREKK_INFO = 'BrandPage';
const BRAND_WEBTREKK_INFO = 'brand';

const BRAND_PAGE_DOUBLE_COLUMN_IMG_SIZE = '300-443';
const BRAND_PAGE_SINGLE_COLUMN_IMG_SIZE = '400-596';

export {
  FORBIDDEN_URLS,
  BRAND_PAGE_WEBTREKK_INFO,
  BRAND_PAGE_DOUBLE_COLUMN_IMG_SIZE,
  BRAND_PAGE_SINGLE_COLUMN_IMG_SIZE,
  BRAND_WEBTREKK_INFO,
};
